module.exports = __webpack_public_path__ + "img/verify.672e3777.png";